export default "__VITE_ASSET__BPEs2Rd8__"